/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
// PropTypes no es capaz de ver que solo acepta los tipos submit y button
import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import uuidv4 from "uuid/v4";

const AsButton = ({
  uuid,
  disabled,
  onClick,
  buttonClassName,
  buttonType,
  onMouseEnter,
  onMouseLeave,
  children
}) => (
  <button
    key={uuid}
    disabled={disabled}
    id={uuid}
    onClick={event => onClick(event)}
    className={buttonClassName}
    type={buttonType}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </button>
);
const AsLink = ({ uuid, buttonClassName, onClick, onMouseEnter, onMouseLeave, children }) => (
  <a
    aria-haspopup="true"
    aria-expanded="true"
    id={uuid}
    key={uuid}
    href="#"
    onClick={event => onClick(event)}
    className={buttonClassName}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </a>
);

const TooltipButton = ({
  tag,
  onClick,
  buttonClassName,
  buttonTextClassName,
  iconClassName,
  rightIconClassName,
  buttonText,
  tooltipText,
  tooltipPosition,
  disabled,
  isSubmit,
  icon,
  rightIcon
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setTimeout(() => setIsOpen(!isOpen), 100);
  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  const buttonType = isSubmit ? "submit" : "button";
  const setTrue = () => {
    if (isOpen !== true) setIsOpen(true);
  };
  const setFalse = () => {
    if (isOpen !== false) setIsOpen(false);
  };
  return tag === "a" ? (
    <AsLink
      disabled={disabled}
      uuid={uuid}
      onClick={event => onClick(event)}
      buttonClassName={buttonClassName}
      type={buttonType}
      onMouseEnter={setTrue}
      onMouseLeave={setFalse}
    >
      {icon}
      {iconClassName && <span className={iconClassName} />}
      {buttonText && <span className={buttonTextClassName}>{buttonText}</span>}
      {rightIconClassName && <i className={rightIconClassName} />}
      {rightIcon}
      {tooltipText && (
        <Tooltip
          className="zIndex"
          placement={tooltipPosition}
          isOpen={isOpen}
          target={uuid}
          toggle={toggle}
        >
          {tooltipText}
        </Tooltip>
      )}
    </AsLink>
  ) : (
    <AsButton
      disabled={disabled}
      uuid={uuid}
      onClick={event => onClick(event)}
      buttonClassName={buttonClassName}
      type={buttonType}
      onMouseEnter={setTrue}
      onMouseLeave={setFalse}
    >
      {icon}
      {iconClassName && <span className={iconClassName} />}
      {buttonText && <span className={buttonTextClassName}>{buttonText}</span>}
      {rightIconClassName && <i className={rightIconClassName} />}
      {rightIcon}
      {tooltipText && (
        <Tooltip
          className="zIndex"
          placement={tooltipPosition}
          isOpen={isOpen}
          target={uuid}
          toggle={toggle}
        >
          {tooltipText}
        </Tooltip>
      )}
    </AsButton>
  );
};

TooltipButton.propTypes = {
  tag: PropTypes.string,
  onClick: PropTypes.func,
  buttonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipPosition: PropTypes.string,
  disabled: PropTypes.bool,
  buttonTextClassName: PropTypes.string,
  rightIconClassName: PropTypes.string,
  isSubmit: PropTypes.bool,
  icon: PropTypes.node,
  rightIcon: PropTypes.node
};

TooltipButton.defaultProps = {
  tag: "button",
  onClick: () => {},
  buttonClassName: "btn",
  iconClassName: "",
  buttonText: "",
  tooltipText: "",
  buttonTextClassName: "",
  rightIconClassName: "",
  tooltipPosition: "top",
  disabled: false,
  isSubmit: false,
  icon: null,
  rightIcon: null
};

const ButtonPropTypes = {
  uuid: PropTypes.string,
  onClick: PropTypes.func,
  buttonClassName: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.node.isRequired
};
const ButtonDefaultProps = {
  uuid: "",
  onClick: () => {},
  buttonClassName: "",
  onMouseEnter: () => {},
  onMouseLeave: () => {}
};

AsButton.propTypes = {
  ...ButtonPropTypes,
  disabled: PropTypes.bool,
  buttonType: PropTypes.string
};

AsButton.defaultProps = {
  ...ButtonDefaultProps,
  disabled: false,
  buttonType: "button"
};

AsLink.propTypes = ButtonPropTypes;
AsLink.defaultProps = ButtonDefaultProps;

export default TooltipButton;
